import { useAtom } from 'jotai';
import { surveyServiceAtom } from '@/store';

export const useSurveyService = () => useAtom(surveyServiceAtom);
